/**
 * LoadingScreen Component
 * Simple loading state
 */
import React from 'react';

interface LoadingScreenProps {
  message?: string;
}

export const LoadingScreen: React.FC<LoadingScreenProps> = ({ 
  message = 'Chargement...' 
}) => (
  <div className="min-h-screen flex items-center justify-center bg-neutral">
    <p className="text-gray-600">{message}</p>
  </div>
);

export default LoadingScreen;
